/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log("Expanse theme (" + theme.settings.themeVersion + ") by ARCHΞTYPE | Learn more at https://archetypethemes.co");
}

(function () {
  "use strict";

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }

  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };
  

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    theme.customerTemplates();
    //if (theme.settings.isCustomerTemplate) {
    //  console.log("This isCustomerTemplate is a truthy value");
    //  theme.customerTemplates();
   // }

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  const alsoAvailableInGrid = document.getElementById('also-available-in-grid');
  if (alsoAvailableInGrid) {
    const rawGidData = alsoAvailableInGrid.getAttribute('data-product-gids');
    let productGids;
    try {
      productGids = JSON.parse(rawGidData);
      if(productGids[0].startsWith('[')) {
        productGids[0] = productGids[0].substring(1, productGids[0].length);
      }
      if(productGids[productGids.length - 1].endsWith(']')) {
        productGids[productGids.length - 1] = productGids[productGids.length - 1].substring(0, productGids[productGids.length - 1].length - 1);
      }
    } catch (error) {
      console.error('Error parsing GIDs:', error);
      return;
    }

    const query = `
      query getProduct($id: ID!) {
        product(id: $id) {
          title
          handle
          availableForSale
          vendor
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          compareAtPriceRange {
            minVariantPrice {
              amount
            }
          }
          featuredImage {
            url
            altText
          }
        }
      }
    `;

    const fetchProductByGid = (gid) => {
      return fetch('/api/2023-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '4515c9dd2a817dd98ede81990773616d',  // Replace with your access token
        },
        body: JSON.stringify({
          query,
          variables: { id: gid },
        }),
      })
      .then(response => response.json())
      .then(responseData => {
        const product = responseData?.data?.product;
        if (!product || !product.availableForSale) {
          return null;
        }
        return product;
      })
      .catch(error => {
        console.error('Error fetching product:', error);
        return null;
      });
    };

    // Fetch products by GID and render them dynamically
    Promise.all(productGids.map(fetchProductByGid))
      .then(products => {
        products.forEach(product => {
          if (product) {
            // Calculate if the product is on sale
            const isOnSale = product.compareAtPriceRange && product.compareAtPriceRange.minVariantPrice.amount > product.priceRange.minVariantPrice.amount;

            // Format price display logic
            const minPrice = parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2);
            const maxPrice = parseFloat(product.priceRange.maxVariantPrice.amount).toFixed(2);
            const currencySymbol = product.priceRange.minVariantPrice.currencyCode === 'USD' ? '$' : product.priceRange.minVariantPrice.currencyCode;
            let priceDisplay;

            // If the product has varying prices, use the "from" format
            if (minPrice !== maxPrice) {
              priceDisplay = `from ${currencySymbol}${minPrice}`;
            } else {
              priceDisplay = `${currencySymbol}${minPrice}`;
            }

            const productHtml = `
              <div class="grid-item grid-product grid-product-image-breathing-room--true">
                <a href="/products/${product.handle}" class="grid-item__link">
                  <div class="grid-product__image-wrap">
                    <div class="grid-product__tags">
                      ${!product.availableForSale ? `
                        <div class="grid-product__tag grid-product__tag--sold-out">
                          Sold Out
                        </div>` : ''}
                      ${isOnSale ? `
                        <div class="grid-product__tag grid-product__tag--sale">
                          Sale
                        </div>` : ''}
                    </div>

                    <div class="grid__image-ratio grid__image-ratio--square">
                      <img class="grid__image-contain" src="${product.featuredImage.url}" alt="${product.featuredImage.altText}" />
                    </div>
                  </div>
                  
                  <div class="grid-item__meta">
                    <div class="grid-item__meta-main">
                      <div class="grid-product__title">${product.title}</div>
                      <div class="grid-product__vendor">${product.vendor}</div>
                    </div>
                    <div class="grid-item__meta-secondary">
                      <div class="grid-product__price">
                        ${isOnSale ? `
                          <span class="grid-product__price--original">
                            ${currencySymbol}${parseFloat(product.compareAtPriceRange.minVariantPrice.amount).toFixed(2)}
                          </span>` : ''}
                        <span class="grid-product__price--current">
                          <span aria-hidden="true" class="grid-product__price--from"><span>from</span> ${currencySymbol}${minPrice}</span>
                          <span class="visually-hidden"><span>from</span> ${currencySymbol}${minPrice}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            `;
            alsoAvailableInGrid.insertAdjacentHTML('beforeend', productHtml);
          }
        });
      })
      .catch(error => {
        console.error('Error fetching products:', error);
      });
  }
});

/*
Warning: the following three color scheme functions are inert and inaccessible at the moment
*/

function setOrangeScheme() {
  var r = document.querySelector(':root');
  r.style.setProperty('--colorTopAdSpace', 'white');
  r.style.setProperty('--colorBtnPrimary', '#D16F20'); // # heavy orange
  r.style.setProperty('--colorBtnPrimaryText', '#301913'); // # brown
  r.style.setProperty('--colorProfileTableLabel', '#B85315'); // # medium orange
  r.style.setProperty('--colorProfileTableValue', '#7C4213'); // # brown/black
  r.style.setProperty('--colorProfileTableBg', '#FFEADB'); // # light orange
  r.style.setProperty('--colorScheme1Bg', '#F9C8A7'); // announcement bar, autodeliver savings 
  r.style.setProperty('--colorToolbarText', '#B85315'); // announcement bar, autodeliver savings
  r.style.setProperty('--colorScheme2Bg', '#a77a62'); // brown "back button" and "double the fun" island
  r.style.setProperty('--colorScheme2Text', '#29170a'); // brown "back button" and "double the fun" island
  r.style.setProperty('--yotpoStarsColor', '#E67025');
}

function setBlueScheme() {
  var r = document.querySelector(':root');
  r.style.setProperty('--colorTopAdSpace', 'white'); 
  r.style.setProperty('--colorBtnPrimary', '#1F4167'); // # earl grey blue
  r.style.setProperty('--colorBtnPrimaryText', 'white'); // # white 
  r.style.setProperty('--colorProfileTableLabel', '#1F4167'); // # medium orange
  r.style.setProperty('--colorProfileTableValue', '#17314F'); // # brown/black
  r.style.setProperty('--colorProfileTableBg', '#BBD9EC'); // # light orange
  r.style.setProperty('--colorScheme1Bg', '#1F4167'); // announcement bar
  r.style.setProperty('--colorScheme1Text', 'white'); // brown "back button" and "double the fun" island
  r.style.setProperty('--colorToolbarText', '#1F4167'); // announcement bar font color
  r.style.setProperty('--colorScheme2Bg', '#BBD9EC'); // brown "back button" and "double the fun" island
  r.style.setProperty('--colorScheme2Text', '#1F4167'); // brown "back button" and "double the fun" island
  r.style.setProperty('--yotpoStarsColor', '#7e8faa');
}

function setPurpleScheme() {
  var r = document.querySelector(':root');
  r.style.setProperty('--colorTopAdSpace', 'white'); 
  r.style.setProperty('--colorBtnPrimary', '#714256'); // # 
  r.style.setProperty('--colorBtnPrimaryText', 'white'); // # white 
  r.style.setProperty('--colorProfileTableLabel', '#714256'); // # medium orange
  r.style.setProperty('--colorProfileTableValue', '#4D2E3B'); // # brown/black
  r.style.setProperty('--colorProfileTableBg', '#D5BECE'); // # light orange
  r.style.setProperty('--colorScheme1Bg', '#714256'); // announcement bar
  r.style.setProperty('--colorScheme1Text', 'white'); // announcement bar
  r.style.setProperty('--colorToolbarText', '#714256'); // announcement bar font color
  r.style.setProperty('--colorScheme2Bg', '#714256'); // brown "back button" and "double the fun" island
  r.style.setProperty('--colorScheme2Text', 'white'); // brown "back button" and "double the fun" island
  r.style.setProperty('--yotpoStarsColor', '#c39aac');
}